const APP_CONFIG = {
  localhost: {
    apiRoot: 'http://localhost:8080',
  },
  production: {
    apiRoot: '/api',
  },
};

const getAppConfig = () => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

  if (env === 'production') return APP_CONFIG.production;

  return APP_CONFIG.localhost;
};

const AppConfig = getAppConfig();

export default AppConfig;
